import STRINGS from './strings'

const appList = [
  {
    icon: '/assets/images/farmer',
    alt: STRINGS.COMMON.DEHAAT_FARMER_APP,
    appName: STRINGS.COMMON.DEHAAT_FARMER_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=app.intspvt.com.farmer',
  },
  {
    icon: '/assets/images/business-app',
    alt: STRINGS.COMMON.DEHAAT_BUSINESS_APP,
    appName: STRINGS.COMMON.DEHAAT_BUSINESS_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=com.intspvt.app.dehaat2',
  },
]

export default appList
